module.exports = __webpack_public_path__ + "static/media/icon-supplier-discovery-white.5788638d.svg";